<template>
  <div id="family_manu">
    <v-layout wrap class="pr-4 pl-4 mt-4">
      <v-flex xs12 class="button-container pr-0 text-xs-right">
        <div class="d-inline-flex" v-if="selectedData">
          <v-btn class="pf-btn pf-btn-cancel" @click="reset">
            <v-icon size="16" class="pr-1">cancel</v-icon>
            <div>Cancel</div>
          </v-btn>
          <v-btn class="pf-btn pf-btn-save" @click="save">
            <v-icon size="16" class="pr-1">check_circle</v-icon>
            <div>Save</div>
          </v-btn>
        </div>
      </v-flex>
    </v-layout>
    <!-- <p class="ml-4 mb-5 mt-4 pf-menu-text">Choose the family statuses for each menu items. The menu will be available only for families with the selected statuses</p> -->
    <v-layout class="ml-4 mr-4 flex-column">
      <h4 class="mb-4">Set the signup form fields</h4>
      <v-layout wrap class="mb-3">
        <v-flex sm1><b class="pf-font-18">#</b></v-flex>
        <v-flex sm4><b class="pf-font-18">Field</b></v-flex>
        <v-flex sm7><b class="pf-font-18">Status</b></v-flex>
      </v-layout>
      <v-layout wrap v-for="(menu, i) in fieldSettings" :key="i">
        <v-flex sm1 class="flex-align-center pf-menu-text pf-font-18">{{ i + 1 }}</v-flex>
        <v-flex sm4 class="flex-align-center pf-menu-text pf-font-18">{{ menu.title }}</v-flex>
        <v-flex sm7 class="flex-align-center pf-menu-text pf-font-18">
          <v-radio-group v-model="menu.status" row @change="changedData()">
            <v-radio
              v-for="(status, j) in fieldStatuses"
              :key="j"
              :label="`${status.text}`"
              :value="status.name"
            ></v-radio>
          </v-radio-group>
        </v-flex>
      </v-layout>
    </v-layout>
    <v-layout wrap class="pr-4 pl-4 mt-4">
      <v-flex xs12 class="button-container pr-0 text-xs-right">
        <div class="d-inline-flex" v-if="selectedData">
          <v-btn class="pf-btn pf-btn-cancel" @click="reset">
            <v-icon size="16" class="pr-1">cancel</v-icon>
            <div>Cancel</div>
          </v-btn>
          <v-btn class="pf-btn pf-btn-save" @click="save">
            <v-icon size="16" class="pr-1">check_circle</v-icon>
            <div>Save</div>
          </v-btn>
        </div>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
/* global session store  */
/* eslint-disable */
import swal from 'sweetalert2';
// import { mapGetters } from 'vuex';
import { getCollection, update } from '../../helpers/helpers';

export default {
  name: 'family_menu',
  // components: {
  // },
  data: () => ({
    fieldSettingsBackup: {},
    selectedData: false,
    fieldStatuses: [
      { name: 'on', text: 'On' },
      { name: 'off', text: 'Off' }
    ],
    adminSettings: null,
    fieldSettings: [
      {
        name: 'AgencyIntroduction',
        title: 'Agency Custom Introduction',
        status: 'off'
      },
      {
        name: 'CaseworkerName',
        title: 'Caseworker Name',
        status: 'off'
      },
      {
        name: 'PCType',
        title: 'Type of Computer',
        status: 'off'
      },
      {
        name: 'TechnologyExperience',
        title: 'Technology Experience',
        status: 'off'
      },
      {
        name: 'SecurityLink',
        title: 'Security Link',
        status: 'off'
      },
      {
        name: 'SecurityParagraph',
        title: 'Security Paragraph',
        status: 'off'
      }
    ]
  }),
  beforeRouteEnter (to, from, next) {
    if (!session.isOnline()) {
      next({ path: '/login' });
    } else {
      next();
    }
  },
  computed: {
    Agency: {
      set (value) {
        store.commit('setAgency', value);
      },
      get () {
        return store.state.Agency;
      }
    }
  },
  async created () {
    window.getApp.$emit('pageSubHeader', 'Form Fields');

    /* Fetch the admin menu settings */
    if (!this.Agency.is_super_admin) {
      await this.fetchAdminMenuSettings();
    }

    if (this.Agency && this.Agency.signup_fields_settings && Object.keys(this.Agency.signup_fields_settings).length) {
      this.fieldSettings = this.Agency.signup_fields_settings && Object.keys(this.Agency.signup_fields_settings).length ? this.Agency.signup_fields_settings : this.fieldSettings;
    }
    
    /* Sync with admin menu settings */
    if (!this.Agency.is_super_admin) {
      await this.syncWithAdminMenu();
    }

    this.fieldSettingsBackup = JSON.parse(JSON.stringify(this.fieldSettings));
  },
  methods: {
    changedData () {
      this.selectedData = true;
    },
    hideButtons () {
      this.selectedData = false;
    },
    reset () {
      this.fieldSettings = JSON.parse(JSON.stringify(this.fieldSettingsBackup));
      this.hideButtons();
    },
    async fetchAdminMenuSettings () {
      if (!this.Agency.is_super_admin) {
        let { error, data, status } = await getCollection('Agency', true, 0, '', { is_super_admin: true }, 'signup_fields_settings');
        if (error) {
          console.log('error', error);
          this.snackbar = {
            show: true,
            color: 'red',
            text: 'Failed to fetch the admin data'
          };
        } else {
          data = data && data.length ? data[0] : null;
          if (data && data.signup_fields_settings && Object.keys(data.signup_fields_settings).length) {
            this.adminSettings = data.signup_fields_settings;
          }
        }
      }
    },
    async syncWithAdminMenu () {
        if (!this.Agency.is_super_admin) {
            /* Sync with the admin menu settings */
            for (let h = 0; h < this.adminSettings.length; h++) {
                let adminSetting = this.adminSettings[h];

                /* Check if admin setting exists in field settings */
                let fieldIndex = this.fieldSettings.findIndex(x => x.name === adminSetting.name);
                if (fieldIndex > -1) {
                    if (!adminSetting.status || adminSetting.status === 'off') {
                        /* Remove the setting */
                        this.fieldSettings.splice(fieldIndex, 1);
                    }
                } else {
                    /* Add the setting */
                    this.fieldSettings.push(adminSetting);
                }            
            }
        }
    },
    async save () {
        this.selectedData = true;
        if (Object.keys(this.fieldSettings).length) {
            this.Agency.signup_fields_settings = this.fieldSettings;
        }
        let { error, data, status } = await update('Agency', this.Agency, this.Agency.id);
        if (error) {
            console.log('error', error);
            this.snackbar = {
            show: true,
            color: 'red',
            text: 'Failed to update the data'
            };
        } else {
            swal.fire({
            type: 'success',
            title: 'Signup fields updated successfully',
            showConfirmButton: false,
            timer: 2500,
            onClose: () => {
                this.hideButtons();
            }
            });
        }
    }
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/Settings/signup.vue